<div class="container-fluid py-4" style="font-family: 'Poppins', sans-serif;">
    <div class="container text-center">
        <!-- Section Title -->
        <div class="text-center mb-4">
            <h1 class="fw-bolder py-5"
                style="color: #273C66; font-size: 1.9rem; font-family: 'Poppins', sans-serif; letter-spacing: 2px; text-decoration: underline; text-decoration-color: red; text-underline-offset: 5px;">
                Let's start your journey now
            </h1>
        </div>


        <!-- Offerings Grid -->
        <div class="row text-center mt-5">
            <!-- Financial Planning -->
            <div class="col-md-3 col-sm-6 mb-3">
                <a [routerLink]="['/financial-planning']" class="text-decoration-none">
                    <div class="card compact-card p-2 shadow-sm h-100">
                        <img src="assets\servicplanningimages\FP.png" alt="Financial Planning"
                            class="img-fluid mb-2 compact-img">
                        <h6 class="card-title">Financial Planning</h6>
                    </div>
                </a>
            </div>

            <!-- Retirement Planning -->
            <div class="col-md-3 col-sm-6 mb-3">
                <a [routerLink]="['/retirement-planning']" class="text-decoration-none">
                    <div class="card compact-card p-2 shadow-sm h-100">
                        <img src="assets\servicplanningimages\Rp.svg" alt="Retirement Planning"
                            class="img-fluid mb-2 compact-img">
                        <h6 class="card-title">Retirement Planning</h6>
                    </div>
                </a>
            </div>

            <!-- Early Retirement -->
            <div class="col-md-3 col-sm-6 mb-3">
                <a [routerLink]="['/early-retirement-planning']" class="text-decoration-none">
                    <div class="card compact-card p-2 shadow-sm h-100">
                        <img src="assets\servicplanningimages\ER.png" alt="Early Retirement"
                            class="img-fluid mb-2 compact-img">
                        <h6 class="card-title">Early Retirement</h6>
                    </div>
                </a>
            </div>

            <!-- Children Education Planning -->
            <div class="col-md-3 col-sm-6 mb-3">
                <a [routerLink]="['/children-education-planning']" class="text-decoration-none">
                    <div class="card compact-card p-2 shadow-sm h-100">
                        <img src="assets\servicplanningimages\CE.png" alt="Children Education Planning"
                            class="img-fluid mb-2 compact-img">
                        <h6 class="card-title">Children Education Planning</h6>
                    </div>
                </a>
            </div>
        </div>

        <div class="row mt-3">
            <!-- Empty column for spacing -->
            <div class="col-md-2"></div>

            <!-- Children Marriage Planning -->
            <div class="col-md-3 col-sm-6 mb-3">
                <a [routerLink]="['/child-marriage-planning']" class="text-decoration-none">
                    <div class="card compact-card p-2 shadow-sm h-100">
                        <img src="assets\servicplanningimages\CM.png" alt="Children Marriage Planning"
                            class="img-fluid mb-2 compact-img">
                        <h6 class="card-title">Children Marriage Planning</h6>
                    </div>
                </a>
            </div>

            <!-- Health Insurance -->
            <div class="col-md-3 col-sm-6 mb-3">
                <a [routerLink]="['/health-insurance']" class="text-decoration-none">
                    <div class="card compact-card p-2 shadow-sm h-100">
                        <img src="assets\servicplanningimages\HE.png" alt="Health Insurance"
                            class="img-fluid mb-2 compact-img">
                        <h6 class="card-title">Health Insurance</h6>
                    </div>
                </a>
            </div>

            <!-- Term Plan -->
            <div class="col-md-3 col-sm-6 mb-3">
                <a [routerLink]="['/term-plan']" class="text-decoration-none">
                    <div class="card compact-card p-2 shadow-sm h-100">
                        <img src="assets\servicplanningimages\TM.png" alt="Term Plan"
                            class="img-fluid mb-2 compact-img">
                        <h6 class="card-title">Term Plan</h6>
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>

<div class="container">
    <!-- Section Title -->
    <div class="col-12 text-center">
        <div class="fw-bolder fancy-title mt-5 text-center">
            <h1 class="fw-bolder px-5"
                style="color: #273C66; font-size: 1.9rem; font-family: 'Poppins', sans-serif; letter-spacing: 2px; text-decoration: underline; text-decoration-color: red; text-underline-offset: 5px;">
                Our Offerings
            </h1>
        </div>



        <!-- Investment Section -->
        <div class="row align-items-center mt-5">
            <div class="col-md-4 img-slide-left">
                <h1 class="fw-bolder py-3"
                    style="color: #273C66; font-size: 1.9rem; font-family: 'Poppins', sans-serif; letter-spacing: 2px;">
                    Investment
                </h1>

                <div class="card-img-container">
                    <img src="assets/20220630-article-banner-02.jpg" class="img-fluid rounded shadow">
                </div>
            </div>
            <div class="col-md-8 text-slide-right">
                <div class="p-4 mt-5 fancy-paragraph">
                    <p>
                        It has become challenging for individuals to choose the right product as per their needs from
                        too many options available in the financial market. At SNP Money, we follow a systematic
                        approach to the entire investment process. Our team ensures that every product we recommend
                        brings a positive difference to your financial life.
                    </p>
                    <p>
                        We build lifelong business relationships with our clients to ensure that you achieve all the
                        dreams you envision. Our relationship with you doesn’t end at recommending the right mix of
                        products
                        from mutual funds, bonds, corporate fixed deposits, etc. We regularly review your investments to
                        align them with your evolving and futuristic goals.
                    </p>
                    <p><b>Our investment product offerings include:</b></p>
                    <ul style="text-align: left; margin-left: 0; padding-left: 20px;">
                        <li>Mutual Funds/SIP</li>
                        <li>Fixed Income Products</li>
                        <li>Corporate Fixed Deposits</li>
                        <li>Government Bonds</li>
                        <li>Portfolio Management Services (PMS)</li>
                        <li>Pension Funds</li>
                        <li>Alternate Investment Fund (AIF)</li>
                        <li>NPS</li>
                    </ul>

                </div>
            </div>

            <!-- Insurance Section -->
            <div class="row align-items-center mt-5">
                <div class="col-md-4 order-md-2 img-slide-left">
                    <h1 class="fw-bolder py-3"
                        style="color: #273C66; font-size: 1.9rem; font-family: 'Poppins', sans-serif; letter-spacing: 2px;">
                        Insurance
                    </h1>

                    <div class="card-img-container">
                        <img src="assets/Insurance.jpg" class="img-fluid rounded shadow">
                    </div>
                </div>
                <div class="col-md-8 order-md-1 text-slide-right">
                    <div class="p-4 mt-5 fancy-paragraph">
                        <p>
                            Protecting wealth is as important as creating it. We recommend protection solutions like
                            life insurance and health insurance covers tailored to your needs.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Loan Section -->
            <div class="row align-items-center mt-5">
                <div class="col-md-4 img-slide-left">
                    <h1 class="fw-bolder py-3"
                        style="color: #273C66; font-size: 1.9rem; font-family: 'Poppins', sans-serif; letter-spacing: 2px;">
                        Loan
                    </h1>

                    <div class="card-img-container">
                        <img src="assets/img1.png" class="img-fluid rounded shadow">
                    </div>
                </div>
                <div class="col-md-8 text-slide-right">
                    <div class="p-4 mt-5 fancy-paragraph">
                        <p>
                            SNP Finserv is a web-based platform that provides smooth access to finance through a wide
                            range of retail loan products such as personal loans, business loans, home loans, and loans
                            against properties. We also offer loan transfers and SME loans (working capital) products.
                            You can apply online to get offers from leading financial institutions.
                        </p>
                        <p>For more information, visit:
                            <a href="https://snpfinserv.com/" target="_blank">https://snpfinserv.com/</a>
                        </p>
                        <a href="https://snpfinserv.com/" target="_blank">
                            <img src="assets/snp Image/SNP-FINSERV-Logo_final_012c00640_3891.webp"
                                style="width: 130px;">
                        </a>
                    </div>
                </div>
            </div>